import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { BlogService } from '@pages/blog/blog.service';
import { CardModel } from '@models/admin/schemaModels/card-schema.model';

@Injectable(
  { providedIn: 'root' },
)
export class BlogArticleResolver implements Resolve<CardModel> {
  private readonly blogService = inject(BlogService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CardModel> {
    const id = route.paramMap.get('id');
    return this.blogService.getNewsArticle(id ? parseInt(id, 10) : -1);
  }
}
